import Head from 'next/head'
import { useRouter } from 'next/router'
// import { useUserRQInfo } from '@/components/Common/user-provider/user-provider'
import useGetAuthToken from '@/hooks/use-get-auth-token'

export default function AppsFlyerScript() {
  const router = useRouter()
  const authToken = useGetAuthToken()

  // const { userBasicRQData } = useUserRQInfo()

  const isUSStocksBrandCampaignMarketingPage =
    router.asPath.includes('us-stocks-sem')

  // us-stocks-sem has a apps flyer script ( with different key ) of its own
  if (isUSStocksBrandCampaignMarketingPage) {
    return null
  }

  const jsxAppFlyer = (
    <Head>
      {/* app flyer requires script to be added in the head
        they then asyncly load their js
      */}
      <script
        dangerouslySetInnerHTML={{
          __html: `
        !function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","banners",{banners: {key: "a96e87b4-dcf6-48ef-bac2-d91ad122c47b"}})
        AF('banners', 'showBanner')
        `,
        }}
      />
    </Head>
  )

  // if there's auth token wait for user basic api to resolve
  // if it resolves and has user id in the response, we shouldn't add app flyer
  // for logged in user
  if (authToken) {
    return null
  }

  // if no auth token user is surely not logged in, add app flyer script.
  if (authToken === null) {
    return jsxAppFlyer
  }

  return null
}
